<template>
  <!-- Full-screen fixed overlay (z-index 2000) so it covers the app shell/header entirely,
       exactly like the public /event-diagnostic page. -->
  <div class="demo-root">
    <div class="demo-card">
      <h1>E2M OnAir Meet — Demo Session</h1>
      <p class="sub">
        Join the demo meeting in the desktop app. Open each link on a
        <strong>separate machine</strong> to see a two-person call.
      </p>

      <template v-if="singleRole">
        <button class="btn" :class="singleRole" @click="join(singleRole)">
          Join as {{ label(singleRole) }}
        </button>
        <p class="switch">
          <a href="#" @click.prevent="go(other)">or join as {{ label(other) }} instead</a>
        </p>
      </template>

      <template v-else>
        <button class="btn host" @click="join('host')">Join as Host</button>
        <button class="btn guest" @click="join('guest')">Join as Guest</button>
      </template>

      <p class="hint">
        When the browser asks, allow it to open <strong>E2M OnAir Meet</strong>.
        If it isn’t installed, you’ll be offered the installer.
      </p>
      <p class="download">
        Don’t have the desktop app?
        <a :href="installerUrl">Download the installer</a>
      </p>
    </div>
  </div>
</template>

<script>
import { openDesktopAppOrInstall, E2M_INSTALLER_URL } from "@/mixins/utils";

var LINKS = {
  host: "e2monairmeeting://join?demo=1&uid=99928192",
  guest: "e2monairmeeting://join?demo=1&uid=99928193"
};

export default {
  name: "DemoMeet",
  data() {
    return { installerUrl: E2M_INSTALLER_URL };
  },
  computed: {
    // "host"/"guest" when opened as /demo-meet?role=host, else null (show both).
    singleRole() {
      var r = ((this.$route && this.$route.query && this.$route.query.role) || "").toLowerCase();
      return r === "host" || r === "guest" ? r : null;
    },
    other() {
      return this.singleRole === "host" ? "guest" : "host";
    }
  },
  methods: {
    label(role) {
      return role === "host" ? "Host" : "Guest";
    },
    join(role) {
      openDesktopAppOrInstall(LINKS[role]);
    },
    go(role) {
      this.$router.replace({ query: { role: role } });
    }
  }
};
</script>

<style scoped>
.demo-root {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: radial-gradient(1200px 600px at 50% -10%, #241a4d 0%, #0c0918 55%, #08060f 100%);
  font-family: "Inter", system-ui, "Segoe UI", Arial, sans-serif;
}
.demo-card {
  width: 100%;
  max-width: 460px;
  background: #17202e;
  border: 1px solid rgba(55, 65, 81, 0.5);
  border-radius: 18px;
  padding: 40px 32px;
  text-align: center;
  color: #fff;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
}
.demo-card h1 { font-size: 22px; font-weight: 600; margin: 0 0 10px; }
.sub { font-size: 14px; color: #a6a3c2; margin: 0 0 26px; line-height: 1.5; }
.btn {
  display: block;
  width: 100%;
  padding: 15px 18px;
  margin: 10px 0;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: transform 0.08s ease, opacity 0.2s ease;
}
.btn:hover { transform: translateY(-1px); opacity: 0.95; }
.btn.host { background: linear-gradient(90deg, #7c3aed 0%, #d61f69 100%); }
.btn.guest { background: #273041; border: 1px solid rgba(55, 65, 81, 0.9); }
.switch { display: block; width: 100%; margin: 12px 0 0; text-align: center; }
.switch a {
  display: inline-block !important;
  width: auto !important;
  white-space: nowrap !important;
  word-break: normal !important;
  color: #a6a3c2;
  font-size: 13px;
  text-decoration: underline;
  cursor: pointer;
}
.switch a:hover { color: #fff; }
.hint { font-size: 12px; color: #8c93a1; margin: 22px 0 6px; line-height: 1.5; }
.download { font-size: 13px; color: #a6a3c2; margin: 6px 0 0; }
.download a { color: #b79bff; }
</style>
